<script>
export default {
  methods: {
    goTo(route) {
      window.location.href = window.route(route);
    },
  },
};
</script>